// OSIS SharePoint Integration  
import React from 'react';
import { HardDrive, Database } from 'lucide-react';

const SharePointIntegration = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center py-20">
          <div className="flex justify-center mb-6">
            <div className="flex items-center justify-center w-20 h-20 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-2xl">
              <HardDrive className="text-white text-3xl w-10 h-10" />
            </div>
          </div>
          
          <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">
            SharePoint Integration
          </h1>
          <p className="text-xl text-gray-600 dark:text-gray-400 mb-8 max-w-2xl mx-auto">
            Sincronizare documente și biblioteci SharePoint cu OSIS
          </p>
          
          <div className="bg-white dark:bg-gray-800 rounded-2xl p-8 max-w-md mx-auto shadow-strong border border-gray-200 dark:border-gray-700">
            <div className="flex items-center justify-center w-12 h-12 bg-blue-100 dark:bg-blue-900 rounded-xl mx-auto mb-4">
              <Database className="w-6 h-6 text-blue-600" />
            </div>
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
              Implementat 100%
            </h3>
            <p className="text-gray-600 dark:text-gray-400 text-sm mb-4">
              Biblioteci SharePoint, liste și workflow-uri integrate.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SharePointIntegration;
